import { ads } from "@/constants/ads";
import { useEventTracker } from "@/hooks/useEventTracker";

import GoogleAd from "@/components/GoogleAd";
import TrackImpression from "@/components/TrackImpression";

import SectionWrapper from "../SectionWrapper";

const FeaturedBrands = ({ className = "" }) => {
  const { publishEvent } = useEventTracker();

  return (
    <TrackImpression
      category="Featured Brands Carousel"
      label="Featured Brands Carousel"
      data-testid="featured-brands-section"
      className={className}
      id="div-gpt-ad-brands" // this is required for adblock to function correctly
    >
      <SectionWrapper
        className="container"
        title="Here's a deal worth your attention"
        changeLocation={false}
        onClickEvents={() => {
          publishEvent({
            action: "Click",
            category: "Carousel",
            label: "home featured brands carousel show all",
          });
        }}
      >
        <div className="shadow-low rounded m-xs overflow-hidden min-h-[288px] mt-md">
          <GoogleAd
            adPath={ads.halfTakeover.path}
            targeting={{
              section: "homepage",
            }}
          />
        </div>
      </SectionWrapper>
    </TrackImpression>
  );
};

export default FeaturedBrands;
